import { EventTypes } from '../types';
import { createUserActionBigQueryEvent } from './userAction';
import { createTechnicalBigQueryEvent } from './technical';

const { menu, collection } = EventTypes;

export const BigQueryEvents = {
    [menu.clicked]: createUserActionBigQueryEvent('clicked_on_menu'),
    [menu.createCollection.clicked]: createUserActionBigQueryEvent('clicked_on_create_list'),

    [collection.create.success]: createTechnicalBigQueryEvent('list.created'),
    [collection.item.create.success]: createTechnicalBigQueryEvent('list_item.added'),
    [collection.item.delete.success]: createTechnicalBigQueryEvent('list_item.removed')
};
